export default {
  buttons: {
    sign_in: 'Accedi',
    sign_up: 'Registrati',
    logout: 'Esci',
  },
  logout_confirm: {
    title: 'Uscire?',
    description: 'Sei sicuro di voler uscire?',
    cancel: 'Annulla',
    confirm: 'Esci',
  },
};
